import { render } from "./geritaList.vue?vue&type=template&id=64042a32&scoped=true&ts=true"
import script from "./geritaList.vue?vue&type=script&lang=ts"
export * from "./geritaList.vue?vue&type=script&lang=ts"

import "./geritaList.vue?vue&type=style&index=0&id=64042a32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64042a32"]])

export default __exports__